//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cpf } from 'cpf-cnpj-validator'
import moment from 'moment'
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  nuxtI18n: {
    paths: {
      br: '/trabalhe-conosco'
    }
  },

  async asyncData({ $api }) {
    try {
      const areaOfInterestOptions = await $api.workWithUs.showAreaOfInterest()
      const educationLevelOptions = await $api.workWithUs.showEducationLevel()

      return {
        areaOfInterestOptions,
        educationLevelOptions
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      breadcrumbs: [
        {
          name: 'Home',
          path: '/'
        },
        {
          name: 'Trabalhe Conosco',
          path: '/trabalhe-conosco'
        }
      ],
      form: {},
      empty: {
        name: '',
        email: '',
        document: '',
        birthday: '',
        phone: '',
        city: '',
        uf: '',
        interest_id: '',
        education_level_id: '',
        training_level_id: '',
        curriculum: [],
        message: '',
        share_infos: false
      },
      processing: false,
      isCPFValid: true,
      areaOfInterestOptions: [],
      educationLevelOptions: [],
      formationOptions: [],
      disableFormationOptions: true
    }
  },

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: 'Trabalhe Conosco'
    })
  },

  computed: {
    phoneMask() {
      if (this.form.phone && this.form.phone.length > 14) {
        return '(##) #####-####'
      } else {
        return '(##) ####-####?#'
      }
    },

    ...mapGetters({
      privacy: 'layout/getPrivacy'
    })
  },

  mounted() {
    this.setForm()
  },

  methods: {
    validateCPF() {
      const value = this.form.cpf
      const target = this.$refs.cpf

      if (value) {
        const documentNumbers = value.replace(/\D/g, '')
        const isValid = cpf.isValid(documentNumbers)
        const message = 'O CPF inserido é inválido, revise-o e tente novamente.'

        this.isCPFValid = isValid

        if (!isValid) {
          target.setCustomValidity(message)
        } else {
          target.setCustomValidity('')
        }

        return isValid
      }
    },

    async send() {
      try {
        this.processing = true

        const form = {
          ...this.form,
          birthday: moment(this.form.birthday, 'DD/MM/YYYY').format(
            'YYYY-MM-DD'
          ),
          file_id: this.form.curriculum[0].id
        }

        // Delete unnecessary fields
        delete form.curriculum

        // Send Form
        await this.$api.workWithUs.send(form)

        this.$store.dispatch('modal/show', {
          type: 'success',
          title: 'Sucesso',
          message: 'Obrigado! <br /> Seu currículo foi registrado com sucesso.'
        })

        // Reset form
        this.setForm()

        this.processing = false
      } catch (err) {
        console.log(err)

        this.processing = false

        this.$store.dispatch('modal/show', {
          type: 'danger',
          title: 'Erro',
          message:
            'Houve um problema ao tentar cadastrar seu currículo, por favor, tente novamente em alguns instantes.'
        })
      }
    },

    async handleFormationOptions(value) {
      try {
        const { type } = value

        if (type) {
          const response = await this.$api.workWithUs.showTrainingLevel(type)
          this.formationOptions = response
          this.disableFormationOptions = false
        } else {
          this.formationOptions = []
          this.disableFormationOptions = true
        }
      } catch (err) {
        console.log(err)
      }
    },

    setForm() {
      this.form = cloneDeep(this.empty)
    }
  }
}
